import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function BillingSuccess() {
  const nav = useNavigate();
  const { refreshUser } = useAuth();
  const [state, setState] = useState("checking"); // checking | success | failed | timeout
  const [plan, setPlan] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setState("failed");
      return;
    }
    let stop = false;
    const poll = async () => {
      if (stop) return;
      if (attempts.current >= 6) {
        setState("timeout");
        return;
      }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setPlan(data.plan_id);
          await refreshUser().catch(() => {});
          setState("success");
          return;
        }
        if (data.status === "expired") {
          setState("failed");
          return;
        }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { stop = true; };
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f2f0eb] px-6">
      <div className="bg-white border border-[#0a2540] shadow-hard p-10 max-w-md w-full text-center" data-testid="billing-result">
        {state === "checking" && (<><Loader2 className="animate-spin mx-auto text-[#0055ff]" size={40} /><h1 className="font-heading font-bold text-2xl mt-5">Confirming your payment…</h1><p className="text-[#475569] mt-2">Hang tight, this only takes a moment.</p></>)}
        {state === "success" && (<><CheckCircle2 className="mx-auto text-[#166534]" size={44} /><h1 className="font-heading font-bold text-2xl mt-5">You're on {plan?.toUpperCase()}!</h1><p className="text-[#475569] mt-2">Your subscription is active. Time to build.</p><button data-testid="billing-continue-btn" onClick={() => nav("/dashboard")} className="mt-6 w-full bg-[#ff3b00] text-white font-semibold py-3 hover:bg-[#e63500] transition-colors">Go to dashboard</button></>)}
        {(state === "failed" || state === "timeout") && (<><XCircle className="mx-auto text-[#ff3b00]" size={44} /><h1 className="font-heading font-bold text-2xl mt-5">{state === "timeout" ? "Still processing" : "Payment not completed"}</h1><p className="text-[#475569] mt-2">{state === "timeout" ? "Your payment is taking longer than expected. Check your dashboard shortly." : "No charge was made. You can try again anytime."}</p><button onClick={() => nav("/pricing")} className="mt-6 w-full border border-[#0a2540] py-3 font-semibold hover:bg-[#0a2540] hover:text-white transition-colors">Back to pricing</button></>)}
      </div>
    </div>
  );
}
